import { Component, ViewEncapsulation } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'ls-toast-atom',
  standalone: true,
  imports: [ToastModule],
  templateUrl: './toast-atom.component.html',
  styleUrl: './toast-atom.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ToastAtomComponent {}
